import { Attribution } from 'types'

interface DataParams {
  attr: Attribution
  endDate: string
  startDate: string
}

export const getAllChannelsSum = ({ endDate, startDate, attr }: DataParams) => {
  switch (attr) {
    case 'first':
      return `SELECT COUNT(DISTINCT stats.channel_id), SUM(stats.views), SUM(first.leads), SUM(first.total_orders), SUM(first.total_amount), SUM(first.recurring_payments_amount), SUM(first.orders_amount) FROM source WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}'`
    case 'last':
      return `SELECT COUNT(DISTINCT stats.channel_id), SUM(stats.views), SUM(last.leads), SUM(last.total_orders), SUM(last.total_amount), SUM(last.recurring_payments_amount), SUM(last.orders_amount) FROM source WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}'`
    case 'linear':
      return `SELECT COUNT(DISTINCT stats.channel_id), SUM(stats.views), SUM(linear_source.leads), SUM(linear_source.total_orders), SUM(linear_source.total_amount), SUM(linear_source.recurring_payments_amount), SUM(linear_source.orders_amount) FROM source WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}'`
    case 'ai':
      return `SELECT COUNT(DISTINCT stats.channel_id), SUM(stats.views), SUM(ai_source.leads), SUM(ai_source.total_orders), SUM(ai_source.total_amount), SUM(ai_source.recurring_payments_amount), SUM(ai_source.orders_amount) FROM source WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}'`
    default:
      return ''
  }
}
